import { useTranslation } from 'react-i18next'
import { Skeleton } from '@machobear/design-system'
import { Breadcrumbs } from '@/components/breadcrumbs'
import PageTitle from '@/components/page-title'
import { ListingDetailsCard } from './listing-details-card'
import { ActionsSection } from './actions-section'
import { PageContent, PageContentLeft, PageContentRight } from './page-content'
import { HeaderSection } from './header-section'
import { useListingData } from '../../context/listing-data'
import { ContentSection } from '../../components/content-section'
import { SectionHeader } from '../../components/section-header'
import { TrackPerformanceLink } from '../../components/track-performance-link'
import { AnalyticIndicators } from '../../components/analytic-indicators'
import { Insights } from '../../components/insights'
import { Recommendations } from '../../components/recommendations'
import { Footer } from '../../components/footer'
import { RequiredActionBanner } from '../../components/required-action-banner'

export const DesktopLayout = () => {
  const { t } = useTranslation()
  const { listingAddress, loading } = useListingData()

  return (
    <PageContent>
      <PageTitle>
        <Breadcrumbs
          items={[
            { to: '/listings', label: t('l.listing.view.all_listings.link', 'All Listings') },
            { label: listingAddress }
          ]}
        />
      </PageTitle>

      <PageContentLeft>
        <ListingDetailsCard />
        <ActionsSection />
        <Footer />
      </PageContentLeft>

      <PageContentRight>
        <HeaderSection />

        <RequiredActionBanner />

        <ContentSection roundCorners testId="analytics-section">
          {loading ? (
            <Skeleton.Header />
          ) : (
            <SectionHeader icon="graph_bar" title={t('Analytics')} badge="NEW">
              <TrackPerformanceLink />
            </SectionHeader>
          )}

          <AnalyticIndicators />
          <Insights />
        </ContentSection>

        <ContentSection roundCorners testId="recommendations-section">
          {loading ? (
            <Skeleton.Header />
          ) : (
            <SectionHeader icon="tip" title={t('Recommended for you')} />
          )}

          <Recommendations />
        </ContentSection>
      </PageContentRight>
    </PageContent>
  )
}
